import axios from 'axios';
import { ProductModifier } from '@busdk/storefront-service/dist/models/enums';

const TIMEOUT = 15000;

const abortJourney = async (transactionId: string, productModifier: ProductModifier) => {
    const abortJourneyUrl = `${process.env.REACT_APP_API_BASE_URL}/abortJourney/${process.env.REACT_APP_PRODUCT}/${process.env.REACT_APP_COUNTRY}/${process.env.REACT_APP_BRAND}/${productModifier}/status/${transactionId}`;
    return axios.post(abortJourneyUrl, {}, {
        validateStatus: (status => status === 200),
        timeout: TIMEOUT,
    });
}

export { abortJourney };
